// extracted by mini-css-extract-plugin
export default {"subcategories":"Subcategories_subcategories__SXJ29"};